/**
 * Used for selecting the required energy with a slider.
 * @module
 */
import React, { useEffect, useState } from 'react';
import { Container, Row, Col } from 'reactstrap';

import '../../assets/profile-steering/Conversion';
import { WhToKm } from "../../assets/profile-steering/Conversion";
import '../../styles/schedule.scss';
import { useFormContext, useWatch } from 'react-hook-form';
import StyledSlider from '../styled/StyledSlider';
import * as Types from "../../App";

import UserProfile from "../../data/models/UserProfile";
import { setCookie, getCookie } from "../../data/Cookies";
import useUserData from "../../hooks/useUserData.js";
import useProfileData from '../../hooks/useProfileData';

interface EnergySelectorProps {
    settings: Types.SessionType;
    setSettings: React.Dispatch<React.SetStateAction<Types.SessionType>>,
}
/**
 * 
 * @returns 
 */
export default function EnergySelector() {
    const context = useFormContext();
    const energy = useWatch({ control: context.control, name: "desiredEnergy" });
    const departure = useWatch({ control: context.control, name: "departure" });
	
	// Retrieve info from server
	const { userData, getUserData } = useUserData();
	let id = getCookie("id");
    const { profileData, getProfileData } = useProfileData();
	
	useEffect(() => {
		getUserData(id);
        getProfileData()
    }, [id])

    const [max, setMax] = useState(userData.ev_capacity)
    useEffect(() => {
        let maxEVpower = Math.max(...userData.ev_powers)
        let time = departure.getHours() + ":" + departure.getMinutes()
        let intervals = profileData.intervals.slice(0, profileData.intervals.indexOf(time))
        // Max energy limit in kWh (Intervals are every 15 mins)
        let maxPossible = maxEVpower * intervals.length * 0.25  
        console.log(maxPossible)
        setMax(maxPossible)
    } ,[departure, profileData])
	
    // The component body
    return(
        <Container>
            <Row>
                <Col>
                    <StyledSlider
                        name={"desiredEnergy"} 
                        className="slider" 
                        step={1} 
                        min={0} 
                        max= { Math.min(max, userData.ev_capacity)  } />
                </Col>
            </Row>
            <Row>
                <Col style={{textAlign: "center"}}>
                    <h5 style={{fontSize: '2vh'}}>
                    {Math.round(energy/100)/10} kWh =  {Math.round(energy / userData.ev_consumption)} km
                    </h5>
                </Col>
            </Row>
        </Container>
    );
};
